let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("124I9")).then(() => parcelRequire('3HGjj'));